var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-hea"},[_vm._m(0),_c('div',{staticClass:"banner-option",on:{"click":_vm.navtomore}},[_c('img',{attrs:{"src":require("../assets/phhomeimg/phomeoption.png")}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-logo"},[_c('img',{attrs:{"src":require("../assets/phhomeimg/phhomelogo1.png")}})])
}]

export { render, staticRenderFns }